import React from 'react';

import TextWithHint from '../TextWithHint';

const withHintRenderer = ({ cellData }) => <TextWithHint text={cellData} />;

export default withHintRenderer;
